import HTTPService from '@/api/http/HTTPService'

export default {
  getOne: (siteSlug: string) => HTTPService.get(`site/${siteSlug}/maintenance`),
  preview: (siteSlug: string, file: string) => HTTPService.post(`site/${siteSlug}/maintenance/preview`, file),
  load: (siteSlug: string, file: string) => HTTPService.post(`site/${siteSlug}/maintenance`, file),
}
